import { useStaticQuery, graphql } from 'gatsby';

/**
 * ref: https://css-tricks.com/how-to-the-get-current-page-url-in-gatsby/
 */
const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteUrl
          }
        }
      }
    `
  );
  return site.siteMetadata;
};

export default useSiteMetadata;
